import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { PaymentResultType } from "@/stores/EngineStore/enums/PaymentResultType.ts";
import { useLayoutEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const usePaymentResultURLParam = () => {
  const { setPaymentResult, page, setPage } = useEngineStore(
    useShallow((state) => ({
      setPaymentResult: state.setPaymentResult,
      page: state.page,
      setPage: state.setPage,
    })),
  );

  // useLayoutEffect for better recognisition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentResultType = urlParams.get(URLParam.PaymentResult);

    if (!paymentResultType) {
      if (page === AppPage.PaymentResult) setPage(AppPage.AccommodationPicking);
      return;
    }

    setPaymentResult(paymentResultType as PaymentResultType);

    // eslint-disable-next-line
  }, [window.location.search]);
};
